import React from 'react';
import ProductStore from './product/Store';
import NotificationStore from './notification/Store';
import CartStore from './cart/Store';
import OrderStore from './order/Store';
import HistoryStore from './history/Store';
import FeedStore from './feed/Store';
import AuthStore from './auth/Store';

const AppContext: React.FC = ({ children }): any => {
    return <>
        <AuthStore>
            <NotificationStore>
                <FeedStore>
                    <ProductStore>
                        <HistoryStore>
                            <CartStore>
                                <OrderStore>
                                    {children}
                                </OrderStore>
                            </CartStore>
                        </HistoryStore>
                    </ProductStore>
                </FeedStore>
            </NotificationStore>
        </AuthStore>
    </>
}

export default AppContext;